import UploadDisease from "./UploadDisease";

export default UploadDisease;